import { useState } from "react";
// import { useCart } from "../components/cart-components/CartContext";
import Container from "react-bootstrap/Container";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import Offcanvas from "react-bootstrap/Offcanvas";
// import { FaShoppingCart } from "react-icons/fa";
// import { IoPersonOutline } from "react-icons/io5";
import { IoMenu } from "react-icons/io5";
import { Link } from "react-router-dom";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";
import "../styles.css";

function MyNavBar() {
  // const { cartItems } = useCart();
  // const cartItemCount = cartItems.reduce(
  //   (total, item) => total + item.quantity,
  //   0
  // );

  const [showOffcanvas, setShowOffcanvas] = useState(false);

  const handleClose = () => setShowOffcanvas(false);
  const handleShow = () => setShowOffcanvas(true);

  return (
    <Navbar className="navbar-bgcolor" variant="dark" expand="lg">
      <Container>
        <Navbar.Brand as={Link} to="/" className="my-brand">
          <span className="brand-letter">a</span>dato
        </Navbar.Brand>

        {/* Custom Hamburger Icon */}
        <OverlayTrigger
          placement="bottom"
          overlay={<Tooltip id="menu-tooltip">Menu</Tooltip>}
        >
          <Navbar.Toggle
            aria-controls="offcanvasNavbar"
            onClick={handleShow}
            className="nav-smallmenu"
          >
            <IoMenu size={24} />
          </Navbar.Toggle>
        </OverlayTrigger>

        {/* Offcanvas Menu */}
        <Navbar.Offcanvas
          id="offcanvasNavbar"
          aria-labelledby="offcanvasNavbarLabel"
          placement="start"
          show={showOffcanvas}
          onHide={handleClose}
          className="nav-offcanvas"
        >
          <Offcanvas.Header closeButton>
            <Offcanvas.Title id="offcanvasNavbarLabel">Menu</Offcanvas.Title>
          </Offcanvas.Header>
          <Offcanvas.Body>
            <Nav className="me-auto">
              <Nav.Link as={Link} to="/" onClick={handleClose}>
                Home
              </Nav.Link>
              <Nav.Link as={Link} to="/About" onClick={handleClose}>
                About
              </Nav.Link>
              <Nav.Link as={Link} to="/Products" onClick={handleClose}>
                Products
              </Nav.Link>
              <Nav.Link
                href="https://www.adato.online"
                target="_blank"
                rel="noopener noreferrer"
              >
                Lounge Collection
              </Nav.Link>
              <Nav.Link as={Link} to="/Projects" onClick={handleClose}>
                Projects
              </Nav.Link>
              <Nav.Link as={Link} to="/CustomerServices" onClick={handleClose}>
                Customer Services
              </Nav.Link>
            </Nav>
          </Offcanvas.Body>
        </Navbar.Offcanvas>

        {/* Account and Cart - Hidden for now */}
        {/*
        <div className="navbar-right-actions">
          <OverlayTrigger
            placement="bottom"
            overlay={<Tooltip id="account-tooltip">Account/Login</Tooltip>}
          >
            <Nav.Link as={Link} to="/Login" className="cart-link">
              <IoPersonOutline size={24} />
            </Nav.Link>
          </OverlayTrigger>
          <OverlayTrigger
            placement="bottom"
            overlay={<Tooltip id="cart-tooltip">Cart</Tooltip>}
          >
            <Nav.Link as={Link} to="/Cart" className="cart-link">
              <FaShoppingCart size={24} />
              {cartItemCount > 0 && (
                <span className="cart-badge">{cartItemCount}</span>
              )}
            </Nav.Link>
          </OverlayTrigger>
        </div>
        */}
      </Container>
    </Navbar>
  );
}

export default MyNavBar;



// import { useState } from "react";
// import { useCart } from "../components/cart-components/CartContext";
// import Container from "react-bootstrap/Container";
// import Nav from "react-bootstrap/Nav";
// import Navbar from "react-bootstrap/Navbar";
// import Offcanvas from "react-bootstrap/Offcanvas";
// import { FaShoppingCart } from "react-icons/fa";
// import { IoPersonOutline } from "react-icons/io5";
// import { IoMenu } from "react-icons/io5";
// import { Link } from "react-router-dom";
// import OverlayTrigger from "react-bootstrap/OverlayTrigger";
// import Tooltip from "react-bootstrap/Tooltip";
// import "../styles.css";

// function MyNavBar() {
//   const { cartItems } = useCart();
//   const cartItemCount = cartItems.reduce(
//     (total, item) => total + item.quantity,
//     0
//   );

//   const [showOffcanvas, setShowOffcanvas] = useState(false);

//   const handleClose = () => setShowOffcanvas(false);
//   const handleShow = () => setShowOffcanvas(true);

//   return (
//     <Navbar className="navbar-bgcolor" variant="dark" expand="lg">
//       <Container>
//         <Navbar.Brand as={Link} to="/" className="my-brand">
//           <span className="brand-letter">a</span>dato
//         </Navbar.Brand>

//         {/* Custom Hamburger Icon */}
//         <OverlayTrigger
//           placement="bottom"
//           overlay={<Tooltip id="menu-tooltip">Menu</Tooltip>}
//         >
//           <Navbar.Toggle
//             aria-controls="offcanvasNavbar"
//             onClick={handleShow}
//             className="nav-smallmenu"
//           >
//             <IoMenu size={24} />
//           </Navbar.Toggle>
//         </OverlayTrigger>

//         {/* Offcanvas Menu */}
//         <Navbar.Offcanvas
//           id="offcanvasNavbar"
//           aria-labelledby="offcanvasNavbarLabel"
//           placement="start"
//           show={showOffcanvas}
//           onHide={handleClose}
//           className="nav-offcanvas"
//         >
//           <Offcanvas.Header closeButton>
//             <Offcanvas.Title id="offcanvasNavbarLabel">Menu</Offcanvas.Title>
//           </Offcanvas.Header>
//           <Offcanvas.Body>
//             <Nav className="me-auto">
//               <Nav.Link as={Link} to="/" onClick={handleClose}>
//                 Home
//               </Nav.Link>
//               <Nav.Link as={Link} to="/About" onClick={handleClose}>
//                 About
//               </Nav.Link>
//               <Nav.Link as={Link} to="/Products" onClick={handleClose}>
//                 Products
//               </Nav.Link>
//               <Nav.Link as={Link} to="/LoungeProducts" onClick={handleClose}>
//                 Lounge Products
//               </Nav.Link>
//               <Nav.Link as={Link} to="/Projects" onClick={handleClose}>
//                 Projects
//               </Nav.Link>
//               <Nav.Link as={Link} to="/CustomerServices" onClick={handleClose}>
//                 Customer Services
//               </Nav.Link>
//             </Nav>
//           </Offcanvas.Body>
//         </Navbar.Offcanvas>

//         {/* Account and Cart - Always visible */}
//         <div className="navbar-right-actions">
//           <OverlayTrigger
//             placement="bottom"
//             overlay={<Tooltip id="account-tooltip">Account/Login</Tooltip>}
//           >
//             <Nav.Link as={Link} to="/Login" className="cart-link">
//               <IoPersonOutline size={24} />
//             </Nav.Link>
//           </OverlayTrigger>
//           {/* Cart Link */}
//           <OverlayTrigger
//             placement="bottom"
//             overlay={<Tooltip id="cart-tooltip">Cart</Tooltip>}
//           >
//             <Nav.Link as={Link} to="/Cart" className="cart-link">
//               <FaShoppingCart size={24} />
//               {cartItemCount > 0 && (
//                 <span className="cart-badge">{cartItemCount}</span>
//               )}
//             </Nav.Link>
//           </OverlayTrigger>
//         </div>
//       </Container>
//     </Navbar>
//   );
// }

// export default MyNavBar;
